function unreachable(param) {
  return new Error(`Unreachable case with value ${JSON.stringify(param)}`);
}
export {
  unreachable
};
//# sourceMappingURL=tsUtils.js.map
